var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iCon_Contacts",
    "data-name": "iCon / Contacts",
    transform: "translate(-9 -166.306)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2192",
    "data-name": "Rectangle 2192",
    width: 32,
    height: 32,
    transform: "translate(9 166.306)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-contacts",
    "data-name": "Icon material-contacts",
    d: "M19.521,3.671H6.836A1.841,1.841,0,0,0,5,5.507V16.521a1.841,1.841,0,0,0,1.836,1.836H19.521a1.841,1.841,0,0,0,1.836-1.836V5.507A1.841,1.841,0,0,0,19.521,3.671ZM13.178,6.2a2.065,2.065,0,1,1-2.065,2.065A2.068,2.068,0,0,1,13.178,6.2ZM17.768,15.6H8.589V14.227c0-1.533,3.056-2.295,4.589-2.295s4.589.762,4.589,2.295Z",
    transform: "translate(12 171.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2190",
    "data-name": "Rectangle 2190",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(21 172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2191",
    "data-name": "Rectangle 2191",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(21 191)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.36fab5338ca7508203f1a80c16d1231d.svg";
export { ForwardRef as ReactComponent };